import React from 'react'
import Parser from 'html-react-parser'
import { Link } from 'react-router-dom'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('YourReservations')

type YourReservationsProps = {
    reservationCount?: number
    locale: {
        id: string
    }
    item: {
        teaserTitle: string
        teaserText: string
        target: {
            callToActionCustomText: string
        }
    }
}

const YourReservations = ({ item, locale, reservationCount = 0 }: YourReservationsProps) => {
    const { teaserText, teaserTitle, target } = item

    return reservationCount ? (
        <section className={bem(null)}>
            <h2 className={bem('title')}>{teaserTitle}</h2>
            <p className={bem('description')}>{Parser(teaserText)}</p>
            <Link className={bem('cta')} to={`/${locale.id}/account/reservations/`}>
                {target.callToActionCustomText}
            </Link>
        </section>
    ) : null
}

YourReservations.layoutVariant = ['isc-your-reservations']

export default YourReservations
